import styled, { css } from 'styled-components';

import { mediaMixin, TextButton } from '@zillow/constellation';

export const StyledTextButton = styled(TextButton)`
    && {
        font-size: 12px;
        font-weight: 400;

        ${mediaMixin('lg', css`
            font-size: 14px;
            font-weight: 600;
        `)}

        /* 1024 */
        ${mediaMixin('xl', css`
            font-size: 16px;
        `)}
    }
`;
